export default __webpack_public_path__ + "static/media/img16.9e1e056f.svg";